import styled from 'styled-components';
import { IProps } from './index.types';

export const Container = styled.div<IProps>`
  background-color: ${props => props.theme.colors.surface};
  border-radius: ${props => props.theme.radii.sm};
  border: 1px solid ${props => props.theme.colors.border};
  box-shadow: ${props => props.theme.shadows.sm};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  margin-bottom: ${props => props.theme.spacing.lg};

  div,
  section {
    background-color: ${props => props.theme.colors.surface};
  }
  img {
    width: 28px;
    height: 28px;
  }

  ${props => {
    if (props.height != '') {
      return `
                height: ${props.height} !important;
            `;
    }
  }}
`;

export const SectionLeft = styled.section<IProps>`
  width: 350px;
  max-width: 100%;
  flex: 0 1 350px;
  border-radius: ${props => props.theme.radii.sm} 0 0
    ${props => props.theme.radii.sm};
  overflow: hidden;
  > header {
    ${props => {
      if (
        props.civiliansWounded != 0 ||
        props.civiliansDead != 0 ||
        props.agentDead != 0 ||
        props.agentWounded != 0
      ) {
        return `
                    background: ${props.theme.colors.danger};
                `;
      } else {
        return `
                    background: ${props.theme.colors.warning};
                `;
      }
    }}

    padding: ${props => props.theme.spacing.md}
      ${props => props.theme.spacing.lg};
    border-top-left-radius: ${props => props.theme.radii.md};

    > p {
      color: ${props => props.theme.colors.white};
      margin: 0 !important;
      padding: 0 !important;

      > b {
        color: ${props => props.theme.colors.white};
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
`;

export const Locale = styled.div`
  border-right: 1px solid ${props => props.theme.colors.border};
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.lg};

  p {
    margin: 0 !important;
    padding: 0 !important;
  }

  > div {
    display: flex;
    margin-bottom: 15px;

    > h3 {
      font-style: normal;
      font-weight: ${props => props.theme.typography.weights.semibold};
      font-size: ${props => props.theme.typography.sizes.sm};
      line-height: ${props => props.theme.typography.lineHeights.sm};
    }

    > div {
      margin-left: 15px;
    }
  }
`;

export const Title = styled.h4<IProps>`
  ${props => {
    if (
      props.civiliansWounded != 0 ||
      props.civiliansDead != 0 ||
      props.agentDead != 0 ||
      props.agentWounded != 0
    ) {
      return `
                    color: ${props.theme.colors.danger};
                    font-weight: ${props.theme.typography.weights.semibold};
                    font-size: ${props.theme.typography.sizes.md};
                `;
    } else {
      return `
                    color: ${props.theme.colors.warning};
                    font-weight: ${props.theme.typography.weights.semibold};
                    font-size: ${props.theme.typography.sizes.md};
                `;
    }
  }}
`;

export const SectionRight = styled.section`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.lg};
  border-radius: 0 ${props => props.theme.radii.sm}
    ${props => props.theme.radii.sm} 0;
`;

export const Date = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${props => props.theme.spacing.lg};

  > div {
    display: flex;
    align-items: center;
    gap: ${props => props.theme.spacing.md};
  }

  > p {
    margin: 0;
    align-self: center;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.lg};
  padding-top: ${props => props.theme.spacing.md};
`;

export const ContentLeft = styled.div`
  flex: 1 1 260px;
  min-width: 0;

  > div {
    width: 100%;
    > div {
      display: flex;
      align-items: center;
      margin-bottom: ${props => props.theme.spacing.lg};

      > h4 {
        font-style: normal;
        font-weight: ${props =>
          props.theme.typography.weights.medium} !important;
        font-size: ${props => props.theme.typography.sizes.md} !important;
        line-height: ${props =>
          props.theme.typography.lineHeights.md} !important;
      }

      > p {
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
`;

export const ContentRight = styled.div`
  flex: 2 1 320px;
  min-width: 0;
  margin-left: 0;

  > div {
    > h3 {
      font-style: normal;
      font-weight: ${props => props.theme.typography.weights.medium} !important;
      font-size: ${props => props.theme.typography.sizes.md} !important;
      line-height: ${props => props.theme.typography.lineHeights.md} !important;
    }

    > p {
      font-style: normal;
      font-weight: ${props => props.theme.typography.weights.regular};
      font-size: ${props => props.theme.typography.sizes.xs} !important;
      line-height: ${props => props.theme.typography.lineHeights.xs} !important;
      color: ${props => props.theme.colors.textSecondary};
    }
  }
`;

export const SectionBtn = styled.div`
  float: right;
  display: flex;
`;

export const Aprove = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.colors.success};
  border-radius: ${props => props.theme.radii.md};
  border: none;
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.xl};
  margin-left: ${props => props.theme.spacing.lg};

  > img {
    margin-right: ${props => props.theme.spacing.sm};
  }

  > p {
    margin: 0 !important;
    padding: 0 !important;
    color: ${props => props.theme.colors.white};
  }
`;

export const Reprove = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.danger};
  border-radius: ${props => props.theme.radii.md};
  border: none;
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.xl};
  margin-left: ${props => props.theme.spacing.lg};

  > img {
    margin-right: ${props => props.theme.spacing.sm};
  }

  > p {
    margin: 0 !important;
    padding: 0 !important;
    color: ${props => props.theme.colors.white};
  }
`;

export const Disapproved = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: rgba(214, 69, 69, 0.18) !important;
  background-color: rgba(214, 69, 69, 0.18) !important;
  border-radius: ${props => props.theme.radii.sm};
  padding: ${props => props.theme.spacing.xxs}
    ${props => props.theme.spacing.md};
  gap: ${props => props.theme.spacing.xs};

  > img {
    width: 16px;
    height: 16px;
  }

  > p {
    margin: 0 !important;
    padding: 0 !important;
    color: ${props => props.theme.colors.danger};
    font-size: ${props => props.theme.typography.sizes.sm};
    line-height: ${props => props.theme.typography.lineHeights.sm};

    b {
      color: inherit;
    }
  }
`;

export const Approved = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: rgba(31, 157, 85, 0.18) !important;
  background-color: rgba(31, 157, 85, 0.18) !important;
  border-radius: ${props => props.theme.radii.sm};
  padding: ${props => props.theme.spacing.xxs}
    ${props => props.theme.spacing.md};
  gap: ${props => props.theme.spacing.xs};

  > img {
    width: 16px;
    height: 16px;
  }

  > p {
    margin: 0 !important;
    padding: 0 !important;
    color: ${props => props.theme.colors.success};
    font-size: ${props => props.theme.typography.sizes.sm};
    line-height: ${props => props.theme.typography.lineHeights.sm};

    b {
      color: inherit;
    }
  }
`;

export const Edit = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${props => props.theme.radii.md};
  border: 1px solid ${props => props.theme.colors.borderStrong};
  background-color: ${props => props.theme.colors.surface};
  padding: ${props => props.theme.spacing.xs} ${props => props.theme.spacing.xl};
  margin-left: ${props => props.theme.spacing.lg};

  > img {
    margin-right: ${props => props.theme.spacing.sm};
  }

  > p {
    margin: 0 !important;
    padding: 0 !important;
    color: ${props => props.theme.colors.textPrimary};
  }
`;

export const HistoryButton = styled(Edit)``;
